module.exports = __webpack_public_path__ + "static/media/14.43931146.gif";